import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from './Icons';
export function ProblemSection() {
  return <section className="w-full bg-beige py-10 md:py-24 px-5" data-id="element-433">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-2xl mx-auto" data-id="element-434">
        <div className="flex items-center gap-3 mb-5 md:mb-8" data-id="element-435">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brown-dark/10 flex items-center justify-center" data-id="element-436">
            <AlertTriangleIcon className="w-5 h-5 text-brown-dark" data-id="element-437" />
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-brown-dark" data-id="element-438">
            El Problema Real
          </h2>
        </div>

        <p className="font-body text-lg md:text-xl text-brown-medium leading-relaxed mb-6" data-id="element-439">
          El cuero cabelludo se vuelve más delgado, seco y reactivo con el
          tiempo. Cuando usas champús comerciales cargados de sulfatos, estás{' '}
          <span className="relative inline-block" data-id="element-440">
            <span className="relative z-10 font-semibold text-brown-dark" data-id="element-441">
              echando gasolina al fuego
            </span>
            <span className="absolute bottom-0 left-0 w-full h-2 bg-gold/30 -z-0" data-id="element-442" />
          </span>
          .
        </p>

        <div className="bg-white-soft rounded-xl p-6 md:p-8 border border-gold/20 my-8" data-id="element-443">
          <p className="font-body text-lg text-brown-dark leading-relaxed font-medium" data-id="element-444">
            La picazón que sientes no es falta de limpieza; es una señal de
            auxilio de tus folículos.
          </p>
        </div>

        <p className="font-body text-lg md:text-xl text-brown-medium leading-relaxed" data-id="element-445">
          Si no apagas ese "calor" tisular, el folículo se cierra, la hebra se
          miniaturiza y el aclaramiento se vuelve permanente.{' '}
          <strong className="text-brown-dark font-semibold" data-id="element-446">
            No es genética, es estrés celular ignorado.
          </strong>
        </p>
      </motion.div>
    </section>;
}